import auth from '@udacity/ureact-hoth';

import { publicEnv } from '~/features/environment/public';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { userCatalogQuery, userCatalogSchema } from '../models/user-catalog';
import {
  userHasEnterpriseEnrollmentsQuery,
  userHasEnterpriseEnrollmentsSchema,
} from '../models/user-has-enterprise-enrollments';

export async function getUserType(): Promise<'consumer' | 'enterprise'> {
  const jwt = auth.getJWT();

  if (!jwt) {
    return 'consumer';
  }

  const userId = auth.getCurrentUserId();
  const { hasEnterpriseEnrollments } = await queryUdacityService({
    url: publicEnv.NEXT_PUBLIC_CLASSROOM_CONTENT_URL,
    zodSchema: userHasEnterpriseEnrollmentsSchema,
    authorization: `Bearer ${jwt}`,
    body: JSON.stringify({
      query: userHasEnterpriseEnrollmentsQuery,
      variables: { uid: userId },
    }),
  });

  if (hasEnterpriseEnrollments) {
    return 'enterprise';
  }

  const { hasEnterpriseCatalog } = await queryUdacityService({
    url: publicEnv.NEXT_PUBLIC_EXPERIENCE_URL,
    zodSchema: userCatalogSchema,
    authorization: `Bearer ${jwt}`,
    body: JSON.stringify({
      query: userCatalogQuery,
      variables: { uid: userId },
    }),
  });

  if (hasEnterpriseCatalog) {
    return 'enterprise';
  }

  return 'consumer';
}
